import React from 'react';
import LegalLayout, { H2, P, UL, OL } from '../components/legal/LegalLayout';

// Indefinite Pause Policy — wording VERBATIM from the official document.

export default function PauseIndefinitePage() {
  return (
    <LegalLayout title="INDEFINITE PAUSE POLICY" lastUpdated="August 19th, 2026" testId="pause-indefinite-page">
      <H2 id="1">1. OVERVIEW</H2>
      <P>The Indefinite Pause Policy is designed for long-term holds where a subscriber cannot commit to a fixed 90-day return timeline (e.g., extended travel, medical holds, or parental transitions). This option freezes billing indefinitely while protecting your account structure until you choose to return.</P>

      <H2 id="2">2. HOW THE INDEFINITE PAUSE WORKS</H2>
      <UL items={[
        <><strong>Indefinite Billing Suspension:</strong> Stripe sets payment collection and invoice generation to an indefinite hold (pause collection / paused status with no end date).</>,
        <><strong>No Renewal Charges:</strong> No automatic subscription payments will occur until you manually authorize reactivation.</>,
        <><strong>Permanent Data Vaulting:</strong> Your customized settings, Practice Partner preferences, character progress, and historical logs are securely archived and protected from automatic data purge cycles.</>,
        <><strong>Service Suspension:</strong> Paid platform features are suspended while paused. Your account functions on the free Starter tier during the pause.</>,
      ]} />

      <H2 id="3">3. REACTIVATION &amp; PRICING GUARANTEE</H2>
      <UL items={[
        <><strong>Manual Reactivation Required:</strong> Your subscription will remain paused indefinitely until you manually click Resume Subscription in your dashboard or request reactivation via customer support.</>,
        <><strong>Grandfathered Price Protection:</strong> When you un-pause an indefinitely paused subscription within 12 months of the pause start date, your original subscription price rate will be honoured, protecting you from mid-year plan price increases.</>,
      ]} />

      <H2 id="4">4. DATA PURGE WARNING FOR LONG-TERM INACTIVE PAUSES</H2>
      <UL items={[
        <><strong>Annual Verification:</strong> If an account remains in an Indefinite Pause state for more than 24 consecutive months, HiBFF Ltd will issue a notification email requesting confirmation of account retention.</>,
        <><strong>Abandoned Accounts:</strong> If no response is received within 30 days of the 24-month check-in, the account may be transitioned to a cancelled status, and archived data purged in accordance with our GDPR data minimisation standards.</>,
      ]} />

      <H2 id="5">5. HOW TO REQUEST AN INDEFINITE PAUSE</H2>
      <OL items={[
        <>Email <a href="mailto:support@hibff.com" className="underline text-blue-700">support@hibff.com</a> with the subject “Indefinite Pause”</>,
      ]} />
    </LegalLayout>
  );
}
